import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/33670133353', '_blank');
  };

  return (
    <motion.button
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={handleWhatsAppClick}
      data-testid="whatsapp-button"
      className="fixed bottom-12 right-12 z-50 gold-gradient text-[#1a1a1a] p-5 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-500 group"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle size={28} strokeWidth={1.5} />
      <span className="absolute right-full mr-6 top-1/2 -translate-y-1/2 gold-gradient text-[#1a1a1a] px-8 py-4 rounded-full text-xs uppercase tracking-[0.2em] whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-500 shadow-lg">
        WhatsApp
      </span>
    </motion.button>
  );
};

export default WhatsAppButton;
